import { useSelector } from 'react-redux';

import { selectCurrentEnterpriseCountry } from 'store/modules/enterprise/selectors';

// TODO: Introduce the real react-i18next library to enjoy the nesting keys,
// nesting translations, plurals, etc.
const au = {
  BORE: 'Bore',
  DAM: 'Dam',
  DAM_BOTTOM_UP_MEASUREMENT: 'calculates the water level from the floor of the dam up to the current water level.',
  DAM_HIGH_CRITICAL_ALERT: 'Dam High - Red Alert (Critical)',
  DAM_HIGH_WARNING_ALERT: 'Dam High - Amber Alert (Warning)',
  DAM_LOW_CRITICAL_ALERT: 'Dam Low - Red Alert (Critical)',
  DAM_LOW_WARNING_ALERT: 'Dam Low - Amber Alert (Warning)',
  DAM_SURVEY_FILLING_INSTRUCTION_ONE: 'Enter incremental volume in megalitres (ML) and reduced levels in metres (m).',
  DAM_SURVEY_FILLING_INSTRUCTION_TWO: 'It is optional to add the surface area in m² (sq. m).',
  DAM_TOP_DOWN_MEASUREMENT: 'calculates the water level from the top of the dam down to the current water level.',
  FARMBOT: 'Farmbot',
  HELP_CENTRE: 'Help Centre',
  LIQUID_FERTILISER: 'Liquid Fertiliser',
  LOCALISATION: 'Localisation',
  MOBILE_NUMBER: 'Mobile Number',
  PADDOCK: 'Paddock',
  REDUCED_LEVEL: 'Reduced Level',
  RL: 'RL',
  SMS: 'SMS',
  SQUARE_METERS: 'm²'
};

const us = {
  BORE: 'Well',
  DAM: 'Reservoir',
  DAM_BOTTOM_UP_MEASUREMENT: 'calculates the water level from the floor of the reservoir up to the current water level.',
  DAM_HIGH_CRITICAL_ALERT: 'Reservoir High (Critical)',
  DAM_HIGH_WARNING_ALERT: 'Reservoir High (Warning)',
  DAM_LOW_CRITICAL_ALERT: 'Reservoir Low (Critical)',
  DAM_LOW_WARNING_ALERT: 'Reservoir Low (Warning)',
  DAM_SURVEY_FILLING_INSTRUCTION_ONE: 'Enter incremental volume in cubic feet (cu. ft.) and elevation in feet (ft).',
  DAM_SURVEY_FILLING_INSTRUCTION_TWO: 'It is optional to add the surface area in ft² (sq. ft.).',
  DAM_TOP_DOWN_MEASUREMENT: 'calculates the water level from the top of the reservoir down to the current water level. The measurement may be referred to as the freeboard level.',
  FARMBOT: 'Ranchbot',
  HELP_CENTRE: 'Help Center',
  LIQUID_FERTILISER: 'Liquid Fertilizer',
  LOCALISATION: 'Localization',
  MOBILE_NUMBER: 'Cell Number',
  PADDOCK: 'Field',
  REDUCED_LEVEL: 'Elevation',
  RL: 'Elev.',
  SMS: 'Text',
  SQUARE_METERS: 'ft²'
};

/** A fake react-i18next hook */
const useTranslation = () => {
  const country = useSelector(selectCurrentEnterpriseCountry);
  const translations = ['USA', 'MEX', 'PRY'].includes(country) ? us : au;
  return {
    t: (key: keyof typeof au, fillings?: Record<string, string>) => {
      if (fillings) {
        // ref https://www.i18next.com/translation-function/interpolation
        return (translations[key] || key).replace(
          /{{(\w+)}}/g,
          (_, p1: string) => fillings[p1]
        );
      }
      return translations[key] || key;
    }
  };
};

export default useTranslation;
